import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var List = createReactComponent("List", ["svg", defaultAttributes, [["line", {
  x1: "8",
  y1: "6",
  x2: "21",
  y2: "6",
  key: "xpnqsr"
}], ["line", {
  x1: "8",
  y1: "12",
  x2: "21",
  y2: "12",
  key: "7t48vf"
}], ["line", {
  x1: "8",
  y1: "18",
  x2: "21",
  y2: "18",
  key: "1y6o8k"
}], ["line", {
  x1: "3",
  y1: "6",
  x2: "3.01",
  y2: "6",
  key: "udquin"
}], ["line", {
  x1: "3",
  y1: "12",
  x2: "3.01",
  y2: "12",
  key: "1dcyyx"
}], ["line", {
  x1: "3",
  y1: "18",
  x2: "3.01",
  y2: "18",
  key: "16eb49"
}]]]);
export default List;